import { configureStore } from "@reduxjs/toolkit";
import sliceGetEquipamentos from "./features/equipamentos/slices";
import sliceGetCentralByLoja from "./features/central/slices";
import sliceGetModuloByCentral from "./features/modulo/slices";
import slicePostConfigPtMonAnalogico from "./features/monitoramento/analogico/slices";
import slicePostConfigPtMonDigital from "./features/monitoramento/digital/slices";
import slicePostConfigPtMonMedidor from "./features/monitoramento/medidores/slices";
import sliceGetConfigPtMonAnalogico from "./features/monitoramento/analogico/get-monitoramento/slices";
import sliceGetConfigPtMonDigital from "./features/monitoramento/digital/get-monitoramento/slices";
import sliceGetConfigPtMonMedidor from "./features/monitoramento/medidores/get-monitoramento/slices";
import sliceGetPontosMonitoriaByLoja from "./features/monitoramento/lista-pontos/slices";
import sliceUpdateConfigPtMonAnalogico from "./features/monitoramento/analogico/update-monitoramento/slices";
import sliceUpdateConfigPtMonDigital from "./features/monitoramento/digital/update-monitoramento/slices";
import sliceUpdateConfigPtMonMedidor from "./features/monitoramento/medidores/update-monitoramento/slices";
import sliceDeleteConfigPtMonAnalogico from "./features/monitoramento/analogico/delete-monitoramento/slices";
import sliceDeleteConfigPtMonDigital from "./features/monitoramento/digital/delete-monitoramento/slices";
import sliceDeleteConfigPtMonMedidor from "./features/monitoramento/medidores/delete-monitoramento/slices";
import sliceGetGrupoMonitoramento from "./features/grupos-de-monitoramento/slices";
import sliceLogin from "./features/Login/slices";
import sliceAtivarAcesso from "./features/login-ativar/slices";
import sliceForgotPass from "./features/login-forgot/slices";
import divisoesSlices from "./features/dados-loja/divisoes/slices";
import regionaisSlices from "./features/dados-loja/regionais/slices";
import lojasSlices from "./features/dados-loja/lojas/slices";
import sliceGetDashboardGeral from "./features/dashboard-geral/slices";
import sliceGetDashboardAlertas from "./features/dashboard-geral/alertas/slices";
import sliceGetAlertasByUF from "./features/dashboard-geral/alertas-by-uf/slices";
import sliceGetAlertasAbertos from "./features/alertas/slices";
import sliceGetAlertasByFilter from "./features/alertas/alertas-by-filter/slices";
import slicePutAlertasReconhecer from "./features/alertas/reconhecer/slices";
import slicePutAlertasPlanoDeAcao from "./features/alertas/plano-de-acao/slices";
import slicePostAlertasInserirInformacao from "./features/alertas/inserir-informacao/slices";
import sliceGetRptPtosPanorama from "./features/relatorios/rptPtsPanorama/slices";
import sliceGetRptPtosConfig from "./features/relatorios/rptPtosConfig/slices";
import sliceGetRptDispositivos from "./features/relatorios/rptDispositivos/slices";
import sliceGetRptHistoricoDispositivos from "./features/relatorios/rptHistoricosDispositivos/slices";
import sliceGetRptAlertaDetalhe from "./features/relatorios/rptAlertaDetalhe/slices";
import sliceGetRptAlertaLista from "./features/relatorios/rptAlertaLista/slices";
import sliceListUsuarios from "./features/usuarios-list/slices";
import sliceRegisterUsuario from "./features/usuarios-register/slices";
import slicesGetLojaById from "./features/dados-loja/loja-by-id/slices";
import { getAlertaPlanoDeAcao } from "./features/alertas/plano-de-acao/get-plano-acao/services";
import sliceGetAlertaPlanoDeAcao from "./features/alertas/plano-de-acao/get-plano-acao/slices";
import uploadReducer from "./features/documentacaoAVCB/slices";
import manutencao from "./features/manutencao/slices";
import getDocumentacaoAVCBReducer from "./features/documentacaoAVCB/get-documentacao/slices";
import sliceDeleteDocumentacaoAVCB from "./features/documentacaoAVCB/delete-documentacao/slices";
import slicePostAlertasInserirUsuarioEncaminhado from "./features/alertas/inserir-encaminhado/slices";
import sliceGetAlertasUsuariosEncaminhados from "./features/alertas/get-encaminhado/slices";
import sliceDeleteAlertasUsuariosEncaminhados from "./features/alertas/delete-encaminhado/slices";
import sliceGetAlertasProperty from "./features/alertas/getAll-alertas/slices";
import sliceGetAllNomeDeUsuariosPorLoja from "./features/alertas/getAllNomeDeUsuariosPorLoja/slices";
import ativar2faSlice from "./features/2fa/slices";
import verificar2faSlice from "./features/2fa/validar-2fa/slices";
import sliceConfigLoja from "./features/loja/ConfigLoja/slices";
import sliceGetPontosMonitoriaGeral from "./features/getPontosMonitoramentoPorCliente/slices";
import sliceTecnico from "./features/tecnico/tecnicoConfig/slices";
import tecnicoCmdReducer from "./features/tecnico/comandos/slices";
import sliceExcluirAlerta from "./features/alertas/delete-alerta/slices";
import sliceGetAlertasAbertosPublico from "./features/(ApiKey)/alertas/get/slices";
import actionGetDashboardGeralPublico from "./features/(ApiKey)/Mapa/get/slices";
import usuarioStatusSlice from "./features/usuarios-alterarStatus/slices";
import sliceAuditoriaLogs from "./features/AuditoriaLogs/slices";

export const store = configureStore({
  reducer: {
    equipamentos: sliceGetEquipamentos,
    centraisByLoja: sliceGetCentralByLoja,
    modulosByCentral: sliceGetModuloByCentral,
    configPtMonAnalogico: slicePostConfigPtMonAnalogico,
    configPtMonDigital: slicePostConfigPtMonDigital,
    configPtMonMedidor: slicePostConfigPtMonMedidor,
    getPtMonAnalogico: sliceGetConfigPtMonAnalogico,
    getPtMonDigital: sliceGetConfigPtMonDigital,
    getPtMonMedidor: sliceGetConfigPtMonMedidor,
    updateConfigPtMonAnalogico: sliceUpdateConfigPtMonAnalogico,
    updateConfigPtMonDigital: sliceUpdateConfigPtMonDigital,
    updateConfigPtMonMedidor: sliceUpdateConfigPtMonMedidor,
    deletePtMonAnalogico: sliceDeleteConfigPtMonAnalogico,
    deletePtMonDigital: sliceDeleteConfigPtMonDigital,
    deletePtMonMedidor: sliceDeleteConfigPtMonMedidor,
    pontosMonitoriaByLoja: sliceGetPontosMonitoriaByLoja,
    getLogin: sliceLogin,
    getAtivarAcesso: sliceAtivarAcesso,
    getForgotPass: sliceForgotPass,
    getDivisoes: divisoesSlices,
    getRegionais: regionaisSlices,
    getLojas: lojasSlices,
    getLojaById: slicesGetLojaById,
    getDashboardGeral: sliceGetDashboardGeral,
    getDashboardAlertas: sliceGetDashboardAlertas,
    getAlertasAbertos: sliceGetAlertasAbertos,
    getAlertasByUF: sliceGetAlertasByUF,
    getAlertasByFilter: sliceGetAlertasByFilter,
    putAlertasReconhecer: slicePutAlertasReconhecer,
    putAlertasPlanoDeAcao: slicePutAlertasPlanoDeAcao,
    getGrupoMonitoramento: sliceGetGrupoMonitoramento,
    postAlertasInserirInformacao: slicePostAlertasInserirInformacao,
    getRptPtosPanorama: sliceGetRptPtosPanorama,
    getRptPtosConfig: sliceGetRptPtosConfig,
    getRptDispositivos: sliceGetRptDispositivos,
    getRptHistoricoDispositivos: sliceGetRptHistoricoDispositivos,
    getRptAlertaDetalhe: sliceGetRptAlertaDetalhe,
    getRptAlertaLista: sliceGetRptAlertaLista,
    listUsuarios: sliceListUsuarios,
    registerUsuario: sliceRegisterUsuario,
    getAlertaPlanoDeAcao: sliceGetAlertaPlanoDeAcao,
    upload: uploadReducer,
    getDocumentacaoAVCB: getDocumentacaoAVCBReducer,
    deleteDocumentacaoAVCBById: sliceDeleteDocumentacaoAVCB,
    slicePostAlertasInserirUsuarioEncaminhado,
    getAllUsuariosEncaminhados: sliceGetAlertasUsuariosEncaminhados,
    sliceDeleteAlertasUsuariosEncaminhados,
    getAlertasProperty: sliceGetAlertasProperty,
    getAllNomeDeUsuariosPorLoja: sliceGetAllNomeDeUsuariosPorLoja,
    ativar2fa: ativar2faSlice,
    verificar2fa: verificar2faSlice,
    configLoja: sliceConfigLoja,
    getPontosMonitoriaGeral: sliceGetPontosMonitoriaGeral,
    sliceTecnico: sliceTecnico,
    tecnicoCmd: tecnicoCmdReducer,
    excluirAlerta: sliceExcluirAlerta,
    getAlertasAbertosPublico: sliceGetAlertasAbertosPublico,
    getDashboardGeralPublico: actionGetDashboardGeralPublico,
    usuarioStatus: usuarioStatusSlice,
    manutencao: manutencao,
    auditoria: sliceAuditoriaLogs
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
